// window.js

export const INITIAL_STATE = {
  innerHeight: window.innerHeight,
  innerWidth: window.innerWidth,
  clientWidth: document.documentElement.clientWidth,
};

// action types
const UPDATE_WINDOW_SIZE = "trace-web/window/UPDATE_WINDOW_SIZE";

// reducer
const windowReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_WINDOW_SIZE:
      return {
        ...state,
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        clientWidth: document.documentElement.clientWidth,
      };
    default:
      return state;
  }
};
export default windowReducer;

// action creators
export const updateWindowSize = () => {
  return {
    type: UPDATE_WINDOW_SIZE,
  };
};
